import { imagePath } from 'src/util/formatUrl';

import { categoryList_categoryList_children } from '../../queries/__generated__/categoryList';

import { CategoryItem } from './CategoryList';

export function cleanCategories(categories: categoryList_categoryList_children[]): CategoryItem[] {
    const featuredCategories = categories
        .filter((x) => x.is_featured === 1)
        .map((category) => {
            return {
                image: imagePath(category.image),
                link: category.url_path || 'unknown',
                title: category.name || 'unknown',
            };
        });

    return featuredCategories;
}
